export default {
	note_datefield_close: 'Close',
	note_delete_dialog_confirm_cancel_label: 'No',
	note_delete_dialog_confirm_message: 'Do you really want to delete this note?',
	note_delete_dialog_confirm_ok_label: 'Yes',
	note_delete_dialog_confirm_title: 'Delete note',
	note_fixed_description_label: 'Description',
	note_fixed_maturity_date_label: 'Date',
	note_save_failed_notification: 'Note could not be saved',
	note_saved_notification: 'Note saved',
	note_version_author: 'Author',
	note_version_dialog_cancel: 'Cancel',
	note_version_dialog_confirm_cancel_label: 'No',
	note_version_dialog_confirm_message: 'Do you really want to delete this version?',
	note_version_dialog_confirm_ok_label: 'Yes',
	note_version_dialog_confirm_title: 'Delete note version',
	note_version_time: 'Date',
	note_version_title: 'Title',
	note_version_versions: 'Versions',
};
